import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default ({ doUpdateItem, item }) => {
  const [vTexSettings, setVTexSettings] = useState({
    appKey: '',
    appToken: '',
    baseUrl: '',
    productIndex: '',
  });

  const { i18n } = useTranslation();

  useEffect(() => {
    if (item && item.vtex) {
      setVTexSettings(item.vtex);
    }
  }, [item]);

  const handleInputSettingsChange = (e) => {
    const { name, value } = e.target;
    const updatedSettings = { ...vTexSettings, [name]: value };

    setVTexSettings(updatedSettings);
    doUpdateItem({ vtex: updatedSettings });
  };

  return (
    <>
      <p className="handler-title">Remover item do carrinho VTex</p>

      <div className="common-form-group">
        <label>{i18n.t('Url base')}</label>
        <input
          className="form-control mt-1"
          value={vTexSettings.baseUrl || ''}
          name="baseUrl"
          onChange={(e) => handleInputSettingsChange(e)}
        />
      </div>

      <div className="common-form-group">
        <label>{i18n.t('AppToken')}</label>
        <input
          className="form-control mt-1"
          value={vTexSettings.appToken || ''}
          name="appToken"
          onChange={(e) => handleInputSettingsChange(e)}
        />
      </div>

      <div className="common-form-group">
        <label>{i18n.t('AppKey')}</label>
        <input
          className="form-control mt-1"
          value={vTexSettings.appKey || ''}
          name="appKey"
          onChange={(e) => handleInputSettingsChange(e)}
        />
      </div>

      <div className="common-form-group">
        <label>{i18n.t('Id do Produto')}</label>
        <input
          className="form-control mt-1"
          value={vTexSettings.productIndex || ''}
          name="productIndex"
          onChange={(e) => handleInputSettingsChange(e)}
        />
      </div>
    </>
  );
};
